<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedication</a>
</li>
<li id="level1-front5">
<a href="#/front03">Prologue</a>
</li>
<li id="c001">
<a href="#/c001">PART ONE</a>
</li>
<li id="c01">
<a href="#/c01">1</a>
</li>
<li id="c02">
<span href="#/c02" title="Link target outside of Sample">2</span>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">3</span>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">4</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">5</span>
</li>
<li id="c002">
<span href="#/c002" title="Link target outside of Sample">PART TWO</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">1</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">2</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">3</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">4</span>
</li>
<li id="c5">
<span href="#/c5" title="Link target outside of Sample">5</span>
</li>
<li id="c003">
<span href="#/c003" title="Link target outside of Sample">PART THREE</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">1</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">2</span>
</li>
<li id="c12">
<span href="#/c12" title="Link target outside of Sample">3</span>
</li>
<li id="c13">
<span href="#/c13" title="Link target outside of Sample">4</span>
</li>
<li id="c004">
<span href="#/c004" title="Link target outside of Sample">PART FOUR</span>
</li>
<li id="c14">
<span href="#/c14" title="Link target outside of Sample">1</span>
</li>
<li id="c15">
<span href="#/c15" title="Link target outside of Sample">2</span>
</li>
<li id="c16">
<span href="#/c16" title="Link target outside of Sample">3</span>
</li>
<li id="c17">
<span href="#/c17" title="Link target outside of Sample">4</span>
</li>
<li id="level1-back28">
<span href="#/back01" title="Link target outside of Sample">About the Author</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?14e25e4c